import { useEffect, useState } from "react";
import { HiOutlineClock } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormTurnos from "../FormTurnos/FormTurnos";
import ListTurnos from "../ListTurnos/ListTurnos";
import "./ConsultaTurnos.css";

const ConsultaTurnos = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<HiOutlineClock size={20} />}
					title="Turnos"
					navigate="../cadastro-turnos"
					description="Buscar por Nome"
					buttonLabel="Adicionar Turno"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Turno"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListTurnos
						filters={filters}
						lineSelected={lineSelected ? true : false}
						refreshKey={refreshKey}
					/>
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormTurnos turno={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaTurnos;
